import { createStore } from 'redux';
import { buildInitialState } from './state';
import { reducers } from './reducers';
import getDevToolsEnhancer from './getDevToolsEnhancer';
function reduce(state = buildInitialState(), action) {
    if (reducers[action.type]) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return reducers[action.type](state, action.payload);
    }
    return state;
}
export function createSearchStore() {
    let devToolsEnabled = false;
    try {
        if (process.env.MOCK_PUSH_CLIENTS) {
            devToolsEnabled = process.env.WHSEARCH_UI_REDUX_DEVTOOLS_ENABLED === 'true';
        }
    }
    catch (e) { } // eslint-disable-line no-empty
    return createStore(reduce, getDevToolsEnhancer(devToolsEnabled));
}
//# sourceMappingURL=index.js.map